<template>
  <vs-popup class="company-modal" :title="company.name" :active.sync="showPopup" v-if="company !== null">
    <template>
      <vs-tabs>
        <vs-tab label="Quick edit" @click.native="tab = 'quick-edit'" :active="true">

          <p>{{ company.name }} is momenteel {{ status }}</p>
          <div class="small-spacer"></div>
          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-input
                  class="w-full"
                  label="Openbaar Telefoonnummer"
                  :value="company.phone_number"
                  v-model="company.phone_number"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-input
                  class="w-full"
                  label="Intern Telefoonnummer"
                  :value="company.internal_phone_number"
                  v-model="company.internal_phone_number"
              />
            </div>
          </div>
          <div class="vx-col w-1/2 mb-2">
            <vs-select label="Bezorgtijd" v-model="company.delivery_time" class="float-right w-full">
              <vs-select-item v-for="time in deliveryTimes" :value="time" :text="time + ' minuten'"
                              :style="getColor(time)"/>
            </vs-select>
          </div>
          <div class="spacer"></div>

          <div class="btn-group">

            <vs-button class="float-left" color="danger" type="filled" @click="closeCompany">Sluit Bedrijf</vs-button>
            <vs-button class="float-left" color="success" type="filled" @click="openCompany">Open Bedrijf</vs-button>
          </div>
          <vs-button
              class="mr-3 mb-2 vs-con-loading__container"
              id="save-company-button"
              ref="loadableButton"
              @click="saveCompanyModal()"
              style="text-align: right"
          >Opslaan
          </vs-button>
        </vs-tab>
        <vs-tab label="Orders" @click.native="tab = 'orders'">
          <vs-list>
            <vs-list-item v-if="company !== null" v-for="order in activeOrders" :key="order.id" :title="getOrderTitle(order)" :subtitle="getAddressString(order)">
            </vs-list-item>
          </vs-list>
        </vs-tab>
      </vs-tabs>
    </template>
  </vs-popup>
</template>
<script>
export default {
  data() {
    return {
      company: null,
      showPopup: false,
      orders: [],
      currentTab: "quick-edit",
      deliveryTimes: [30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90],
    };
  },

  computed: {
    status() {
      return this.company.status === 1 ? "open" : "gesloten";
    },

    activeOrders() {
      if (this.company !== null) {
        let id = this.company.id;
        console.log(this.orders)
        return this.orders.filter(function (item) {
          if (item.job !== null) {
            return (item.company.id === id) && (item.job.status !== "DELIVERED");
          } else {
            return (item.company.id === id);
          }
        });
      } else {
        return [];
      }
    },

    popupTitle() {
      if (this.company !== null) {
        return this.tab === "quick-edit" ? this.company.name + " bewerken" : this.company.name + " orders inzien"
      }
    }
  },


  methods: {

    getColor(deliveryTime) {
      if (deliveryTime >= 30 && deliveryTime <= 60) {
        return "color: green;";
      }
      if (deliveryTime > 60 && deliveryTime <= 75) {
        return "color: orange;";
      }
      if (deliveryTime > 75 && deliveryTime <= 90) {
        return "color: red";
      }
    },

    getOrderTitle(delivery) {
      let id = new String(delivery.id);
      let string = id.substring(id.length - 4);
      return delivery.company.name + " #" + string;
    },

    getAddressString(delivery) {
      return "Bestelling naar " + delivery.address.streetname + " " + delivery.address.housenumber + ", " + delivery.address.postal_code + " " + delivery.address.city;
    },

    getPhoneNumber() {
      return this.company.internal_phone_number !== null ? this.company.internal_phone_number : this.company.phone_number;
    },

    saveCompanyModal() {
      let data = new FormData();
      data.append("new", this.company.new ? 1 : 0);
      data.append("phone_number", this.company.phone_number);
      data.append("internal_phone_number", this.company.internal_phone_number);
      data.append("delivery_time", this.company.delivery_time);
      data.append("company_id", this.company.id);
      this.$http.post("https://api.staging.hebtrek.nl/staff/company/quick-edit", data,
          {
            headers: {
              Authorization:
                  "Bearer " + this.$util.getStaffToken(),
            },
          }
      )
          .then(() => {
            this.$util.notify("Gelukt!", "Bedrijfsgegevens zijn succesvol verwerkt", this.$vs);
            this.showPopup = false;
          })
          .catch((error) => {
            this.$util.logError(error, this.$vs);
          });
    },
    closeCompany() {
      this.$http
          .post("https://staffapi.staging.hebtrek.nl/v1/delivery/companies/" + this.company.slug + "/close", {},
              {
                headers: {Authorization: "Bearer " + this.$util.getStaffToken(),},
              })
          .then(() => {
            this.$util.notify("Gelukt!", this.company.name + " is succesvol gesloten.", this.$vs);
            this.company.status = 2;
            this.$events.fire("company-update", this.company);
          })
          .catch((error) => {
            this.$util.logError(error, this.$vs);
          });
    },
    openCompany() {
      this.$http
          .post(
              "https://staffapi.staging.hebtrek.nl/v1/delivery/companies/" + this.company.slug + "/open",
              {},
              this.$util.getConfig()
          )
          .then(() => {
            this.$util.notify("Gelukt!", this.company.name + " is succesvol geopend.", this.$vs);
            this.company.status = 1;
            this.$events.fire("company-update", this.company);
          })
          .catch((error) => {
            this.$util.logError(error, this.$vs);
          });
    },
  },

  mounted() {
    this.$events.listen('open-company-quick-edit', (company, orders) => {
      this.company = company;
      this.showPopup = true;
      this.orders = orders;
      console.log(this.activeOrders);
    });

    this.$events.listen('quick-edit-update', (updatedCompany) => {
      this.company = updatedCompany;
    });
  }
};
</script>
<style>
#save-company-button {
  float: right;
}

.spacer {
  height: 50px;
  margin: 25px 0;
}

.small-spacer {
  height: 12px;
  margin: 12px 0;
}
</style>